export const BLIND_REVIEW_REMINDERS = [
  'Open documents only through this tool. It shows the PDF and nothing the system decided.',
  "Do not open the document's normal page in Opti, and do not search for it in the work queue: they show the category the system chose. If it happens by accident, write `saw category` in Notes and label it anyway.",
  'Change nothing in Opti during this exercise. Corrections are sent back after both passes.',
  "Label from the PDF alone, not from what you know about the patient's case or other systems.",
]
